exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.HomePageLayout_container_2cVcS {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 0 2rem;\n}\n.HomePageLayout_brandWrapper_8zTtQ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.HomePageLayout_brandWrapper_8zTtQ {\n  background-color: #eeeeee;\n}\n", ""]);

// exports
exports.locals = {
	"container": "HomePageLayout_container_2cVcS",
	"brandWrapper": "HomePageLayout_brandWrapper_8zTtQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/HomePage/HomePageLayout.css
// module id = 898
// module chunks = 0